export const LogoMark = ({ className = "h-8 w-8" }) => (
  <img src="/img/brand/mark.png" alt="" aria-hidden="true" draggable="false" className={`block object-contain ${className}`} />
);

export const Logo = ({ testId = "brand-logo" }) => (
  <a href="/" data-testid={testId} className="group flex items-center">
    <img src="/img/brand/logo.webp" alt="BagiPulsa" className="h-7 w-auto transition-transform duration-500 group-hover:scale-[1.04] md:h-8" />
  </a>
);
